import request from '@/plugins/axios'
import systemConfig from '@/plugins/requireConfig/systemConfig.js'

// 查询用户分页
export function userPage(data) {
    return request({
        url: `/${systemConfig.sysPrefix}/sys/user/page`,
        method: 'post',
        data: data
    })
}

// 查询用户列表
export function userList(data) {
    return request({
        url: `/${systemConfig.sysPrefix}/sys/user/list`,
        method: 'post',
        data: data
    })
}

// 查询用户详细
export function userDetail(id) {
    const data = {
        id : id
    };
    return request({
        url: `/${systemConfig.sysPrefix}/sys/user/detail`,
        method: 'post',
        data
    })
}

// 查询用户详细
export function userCurrentInfo() {
    return request({
        url: `/${systemConfig.sysPrefix}/sys/user/currentInfo`,
        method: 'post',
    })
}

// 查询用户详细
export function userInfo(id) {
    const data = {
        id : id
    };
    return request({
        url: `/${systemConfig.sysPrefix}/sys/user/info`,
        method: 'post',
        data
    })
}


// 新增用户
export function userAdd(data) {
    return request({
        url: `/${systemConfig.sysPrefix}/sys/user/add`,
        method: 'post',
        data: data,
        ifEncrypt:true
    })
}

// 修改用户
export function userUpdate(data) {
    return request({
        url: `/${systemConfig.sysPrefix}/sys/user/update`,
        method: 'post',
        data,
        ifEncrypt:true
    })
}

// 删除用户
export function userDelete(id) {
    const data = {
        id: id
    };
    return request({
        url: `/${systemConfig.sysPrefix}/sys/user/delete/`,
        method: 'post',
        data,
        ifEncrypt:true
    })
}

// 改变用户状态
export function changeUserAbled(data) {
    return request({
        url: `/${systemConfig.sysPrefix}/sys/user/changeUserAbled`,
        method: 'post',
        data,
        ifEncrypt:true
    })
}

// 当前用户修改信息
export function userUpdateCurrentInfo(data) {
    return request({
        url: `/${systemConfig.sysPrefix}/sys/user/updateCurrentInfo`,
        method: 'post',
        data,
        ifEncrypt:true
    })
}

// 当前用户修改密码
export function userChangeCurrentPwd(data) {
    return request({
        url: `/${systemConfig.sysPrefix}/sys/user/changeCurrentPwd`,
        method: 'post',
        data,
        ifEncrypt:true
    })
}

export function userUpdateAvatar(data) {
    return request({
        url: `/${systemConfig.sysPrefix}/sys/user/updateAvatar`,
        method: 'post',
        data,
        ifEncrypt:true
    })
}

//管理员重置密码
export function userResetPassword(data) {
    return request({
        url: `/${systemConfig.sysPrefix}/sys/user/resetPwd`,
        method: 'post',
        data
    })
}

// 切换登录部门
export function switchDept(data) {
    return request({
        url: `/${systemConfig.sysPrefix}/sys/user/switchDept?deptId=${data.deptId}`,
        method: 'post',
    })
}
